<app-modal-politica-termo *ngIf="!politicaTermoService.isAcceptedPoliciesAndTerms()"></app-modal-politica-termo>
<article class="article-politicas-termo">

  <h1>POLÍTICA DE PRIVACIDADE</h1>
  <small><b>Data de última atualização: {{ DATA_ULTIMA_ATUALIZACAO_POLITICA }}.</b></small>


  <p>Esta Política de Privacidade (“Política”) indica como as suas informações e dados pessoais serão coletados,
    usados, compartilhados e armazenados em razão do uso dos Serviços relacionados à parceria. Este documento é
    parte integrante dos Termos de Uso, que contêm uma visão geral dos Serviços e, sem prejuízo de outras definições
    atribuídas nesta Política, as definições que são contempladas nos Termos de Uso, aplicam-se a esta Política.</p>

  <p> A {{ RAZAO_SOCIAL }} e a “Parceira”,
    disponibilizam uma conta de pagamento digital com o intuito de facilitar suas Compras em Estabelecimentos e que
    também permite a realização de Saques, Transferência entre Contas, Pagamento de Boletos e Contas de Consumo,
    Recarga de Celular, entre outras funcionalidades (os “Serviços”).</p>

  <p> No contexto da sua adesão aos Serviços e uso dos mesmos, você terá estabelecido uma relação direta com a
    {{ RAZAO_SOCIAL }}, a qual será pautada nos Termos de Uso e em eventuais outros documentos que regerem tal
    relação, conforme o caso. A Parceira, por sua vez, é uma parceira de negócios da Empresa e integra a relação
    estabelecida entre você e a {{ RAZAO_SOCIAL }} na medida em que a Parceira disponibilizara à você, em conjunto
    com a {{ RAZAO_SOCIAL }}], os componentes financeiros necessários à prestação dos Serviços que você selecionar
    junto à {{ RAZAO_SOCIAL }}, incluindo, quando aplicável, a emissão de cartão e a disponibilização de conta de
    pagamento. Em razão da existência dessa relação, essa Política de Privacidade se aplica à forma como a
    {{ RAZAO_SOCIAL }} e a Parceira utilizam os seus dados pessoais de forma conjunta para possibilitar a prestação
    dos Serviços.</p>

  <p> Quando você utiliza os Serviços, você confia seus dados e informações à {{ RAZAO_SOCIAL }} e à Parceira. Estas
    se comprometem a preservar essa confiança. Por isso, este documento foi elaborado com o intuito de esclarecer
    quais dados pessoais são coletados dos usuários dos Serviços (“você”) e a forma de tratamento de tais dados
    pessoais no contexto da prestação dos Serviços.</p>

  <p> A ACEITAÇÃO DESTA POLÍTICA DEVERÁ SER FEITA QUANDO VOCÊ SE CADASTRAR EM NOSSAS APLICAÇÕES (AS “APLICAÇÕES”) PARA
    USUFRUIR DOS SERVIÇOS. A ACEITAÇÃO SE DARÁ NO MOMENTO EM QUE VOCÊ, DE FORMA AFIRMATIVA, CONCORDAR COM O USO DOS
    SEUS DADOS PARA CADA UMA DAS FINALIDADES AQUI DESCRITAS. ISSO INDICARÁ QUE VOCÊ ESTÁ CIENTE E EM TOTAL ACORDO
    COM A FORMA COMO AS SUAS INFORMAÇÕES E OS SEUS DADOS SERÃO UTILIZADOS. CASO VOCÊ NÃO CONCORDE COM ESTA POLÍTICA,
    POR FAVOR, NÃO A ACEITE E NÃO CONTINUE O SEU PROCEDIMENTO DE CADASTRO. TODAVIA, CASO ISSO ACONTEÇA, POR FAVOR,
    EXPLIQUE O MOTIVO DE DISCORDÂNCIA ATRAVÉS DOS CANAIS INDICADOS AO FINAL DESTA POLÍTICA PARA QUE POSSAMOS
    MELHORAR OS SERVIÇOS.</p>

  <p>Este documento foi redigido de forma simples e acessível, contando com vários exemplos de coleta e de uso dos
    dados, justamente para que você possa ler e entender a forma como utilizamos os seus dados para lhe oferecer uma
    experiência segura e confortável durante o uso dos Serviços.</p>

  <h3>Dividimos esta Política da seguinte forma, para facilitar a sua compreensão:</h3>

  <ol>
    <li>Que tipos de dados a {{ RAZAO_SOCIAL }} e a Parceira coletam?</li>
    <li>Com quem os seus dados são compartilhados?</li>
    <li>Onde os dados são armazenados?</li>
    <li>Quais são os direitos dos titulares de dados?</li>
    <li>Por quanto tempo os dados serão armazenados?</li>
    <li>Como funciona a Segurança da Informação?</li>
    <li>Como falar com a [{{ RAZAO_SOCIAL }}]?</li>
    <li>Mudanças na Política</li>
  </ol>

  <h3>1. QUE TIPOS DE DADOS A [{{ RAZAO_SOCIAL }}] E A PARCEIRA COLETAM?</h3>

  <p> Em geral, os dados pessoais que você fornece são usados para que você possa usufruir dos Serviços, bem como para
    que eles possam ser aprimorados. Os seus dados pessoais são utilizados para atingir as finalidades apresentadas
    na tabela abaixo, com as respectivas bases legais, que autorizam o seu tratamento: </p>

  <table cellpadding="0" cellspacing="0">
    <thead>
      <tr>
        <td>Dados Pessoais</td>
        <td>Finalidades</td>
        <td>Base Legal</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>CPF, nome completo, data de nascimento, endereço residencial, endereço de e-mail, nome completo da
          mãe, número de telefone, foto da cédula de identidade ou CNH, uma foto estilo autoretrato (selfie)
          do titular e Autodeclaração de Pessoa Exposta Politicamente(PEP).
        </td>
        <td>
          <ul>
            <li>Verificar a sua identidade;</li>
            <li>Cadastro nos Serviços;</li>
            <li>Análise de crédito;</li>
            <li>Identificar e prevenir eventuais situações de fraude;</li>
            <li>Identificar e prevenir eventuais ameaças de segurança.</li>
          </ul>
        </td>
        <td>Cumprimento de Obrigação Legal e/ou Consentimento.</td>
      </tr>
      <tr>
        <td>IP, hora e data de acesso, geolocalização, dados sobre o seu dispositivo de acesso e cookies.</td>
        <td>
          <ul>
            <li>Coleta automatizada por meio do site ou Aplicações para fins de identificação e prevenção de
              situações de fraude e ameaças de segurança;</li>
            <li>Personalização e aprimoração dos Serviços com base na sua forma de utilzação.</li>
          </ul>
        </td>
        <td>Cumprimento de Obrigação Legal, Consentimento e Legítimo Interesse.</td>
      </tr>
      <tr>
        <td>Perfil e comportamento de compra, volume e número de transações em Estabelecimentos e por meio de
          Aplicações.</td>
        <td>
          <ul>
            <li>Análise comportamental/transacional para fins de identificação e prevenção de situações de
              fraude e ameaças de segurança;</li>
            <li>Análise de crédito.</li>
          </ul>
        </td>
        <td>Cumprimento de Obrigação Legal e Legítimo Interesse.</td>
      </tr>
      <tr>
        <td>Dados gerais de navegabilidade, utilização das Aplicações, funis de eventos.</td>
        <td>
          <ul>
            <li><i>Analytics</i> - reconhecimento de perfis e hábitos de consumo coletivos dos usuários dos
              Serviços, a fim de gerar dados estatísticos que possibilitem melhor compreensão de como se
              dão as interações dos usuários com as Aplicações.</li>
          </ul>
        </td>
        <td>Consentimento e Legítimo Interesse.</td>
      </tr>
    </tbody>
  </table>

  <!-- <p> <img src="/assets/img/politicaprivacidade-tabela.jpg" alt=""></p> -->

  <h3>2. COM QUEM SEUS DADOS SÃO COMPARTILHADOS?</h3>

  <p> Por ser um Serviço que envolve operações de pagamento, a {{ RAZAO_SOCIAL }} e a Parceira podem atuar em conjunto
    com outras empresas para realizar diversas atividades, inclusive para a avaliação da sua capacidade financeira,
    como por meio da verificação de credit score e acompanhamento da situação da sua inscrição no CPF/MF. </p>

  <p> Desta forma, a {{ RAZAO_SOCIAL }} e a Parceira reservam-se no direito de compartilhar as suas informações com
    terceiros no intuito de receber, analisar e tomar decisões sobre solicitações relacionadas aos Serviços. Tais
    compartilhamentos de informações com terceiros podem incluir dados pessoais relativos à sua situação financeira
    e, sempre que for possível, de forma pseudoanonimizada, visando preservar ao máximo a sua privacidade.</p>

  <p> A {{ RAZAO_SOCIAL }} e a Parceira não licenciam, nem transferem seus dados pessoais para ninguém, exceto para as
    modalidades de empresas elencadas abaixo. </p>

  <p> BUREAU DE CRÉDITO: A {{ RAZAO_SOCIAL }} e a Parceira irão compartilhar seus dados pessoais, quando você
    consentir com a adesão aos Serviços, com empresas que realizam a análise de seu perfil pessoal com relação à
    risco de concessão de crédito, a fim de dar maior segurança às operações e evitar eventuais fraudes. </p>

  <p> ANALYTICS: Os dados armazenados pela {{ RAZAO_SOCIAL }} e a Parceira podem vir a ser utilizados para fins de
    reconhecimento de perfis e hábitos de consumo coletivos dos usuários dos Serviços, a fim de gerar dados
    estatísticos (analytics), que possibilitem compreender melhor como é o acesso dos usuários às Aplicações.
    É considerado importante porque, dessa forma, será possível melhorar a prestação de serviços e customizar
    produtos mais direcionados aos interesses dos usuários. Importante: Os dados relacionados a você e utilizados
    para essa finalidade são pseudonimizáveis, não permitindo a sua identificação quando analisados de forma
    agregada, nem tornando identificáveis os titulares dos dados pessoais analisados para finalidades estatísticas.
  </p>

  <p> Parceiros processadores de transações de pagamento e emissão de cartões, informamos que cada qual tem sua
    própria política de privacidade. Desse modo, recomendamos a leitura das suas políticas de privacidade para
    compreensão de quais informações pessoais serão usadas por esses fornecedores.</p>

  <p> PARA RESGUARDAR E PROTEGER OS DIREITOS DA [EMPRESA] E A PARCEIRA: SEM PREJUÍZO DO DISPOSTO NAS LEGISLAÇÕES
    BRASILEIRAS APLICÁVEIS, A {{ RAZAO_SOCIAL }} E A PARCEIRA SE RESERVAM DO DIREITO DE ACESSAR, LER,
    PRESERVAR E DIVULGAR QUAISQUER DADOS NECESSÁRIOS PARA CUMPRIR UMA OBRIGAÇÃO LEGAL OU UMA ORDEM JUDICIAL EMANADA
    DE AUTORIDADES COMPETENTES; FAZER CUMPRIR OU APLICAR OS TERMOS DE USO E OUTROS ACORDOS FIRMADOS COM VOCÊ; OU
    PROTEGER OS DIREITOS, PROPRIEDADE OU SEGURANÇA DA {{ RAZAO_SOCIAL }} E DA PARCEIRA, E SEUS RESPECTIVOS
    REPRESENTANTES, PRESTADORES DE SERVIÇOS, COLABORADORES OU USUÁRIOS.</p>

  <h3>3. ONDE OS DADOS SÃO ARMAZENADOS?</h3>

  <p>A {{ RAZAO_SOCIAL }} e a Parceira podem transferir dados pessoais coletados no Brasil para os EUA. Essa
    transferência ocorrerá quando a empresa responsável pela hospedagem de suas informações, a qual pode
    ser contratada pela {{ RAZAO_SOCIAL }} e/ou pela Parceira, estiver localizada em território americano. No
    entanto, antes de transferir seus dados para outro país, será garantido que o país proporciona o grau de
    proteção de dados pessoais exigido nesta Política de Privacidade, ou que a {{ RAZAO_SOCIAL }} e a Parceira
    garantirão a observância, independentemente da legislação estrangeira, dos princípios, direitos do titular e
    proteção de dados pessoais expostos nesta Política de Privacidade, em consonância com a Lei nº 13.709/18. A
    garantia dessa proteção de seus dados será inclusive sujeita à validação pelo Poder Público brasileiro. </p>

  <p> A {{ RAZAO_SOCIAL }} e a Parceira possuem sede no Brasil e os dados que coletamos são regidos pela lei
    brasileira. Ao acessar ou usar os Serviços ou fornecer dados pessoais para a {{ RAZAO_SOCIAL }} e a
    Parceira, você concorda com o tratamento e a transferência de tais dados para o Brasil e para o EUA, se
    for o caso, observadas as condições expostas no parágrafo acima. </p>

  <p> A {{ RAZAO_SOCIAL }} e a Parceira declaram a Você que seus dados pessoais serão compartilhados entre elas,
    devendo ser mantidos, para fins de cumprimento de regras de KYC e AML, nos termos da regulamentação em vigor.
  </p>

  <h3>4. QUAIS SÃO OS DIREITOS DOS TITULARES DE DADOS?</h3>

  <p> Você sempre poderá optar em não divulgar seus dados para a {{ RAZAO_SOCIAL }} e a Parceira, mas tenha em mente
    que alguns desses dados podem ser essenciais para permitir o seu cadastro, acesso e uso dos Serviços ou de
    alguns dos recursos e produtos oferecidos a Você em conexão com essa Política de Privacidade. Independente
    disso, você sempre possuirá direitos relativos à privacidade e à proteção dos seus dados pessoais. Além de a
    {{ RAZAO_SOCIAL }} e a Parceira se preocuparem com a segurança dos seus dados pessoais, também se preocupam que
    você tenha acesso e conhecimento de todos os seus direitos relativos a dados pessoais.</p>

  <p> Dessa forma, abaixo estão resumidos todos os direitos que você possui sob as leis brasileiras relativas à
    proteção de dados, os quais são:</p>

  <ol type="i">
    <li>Direito de confirmação da existência de atividade de tratamento;</li>
    <li>Direito de acesso;</li>
    <li>Direito de retificação;</li>
    <li>Direito de exclusão ou cancelamento;</li>
    <li>Direito de objeção ou oposição a um tratamento;</li>
    <li>Direito de restringir o tratamento;</li>
    <li>Direito à revisão das decisões automatizadas tomadas com base em seus dados;</li>
    <li>Direito à portabilidade de dados;</li>
    <li>Direito de retirar o seu consentimento;</li>
    <li>Direito de anonimização ou bloqueio de seus dados;</li>
    <li>Direito de não fornecer consentimento e de ser informado sobre as consequências relacionadas;</li>
    <li>Direito de Peticionar perante o Poder Público e exercer seus Direitos e Interesses em Juízo</li>
  </ol>

  <p> Nesse sentido, segue abaixo uma breve explicação e exemplos sobre alguns desses direitos:</p>

  <ul>
    <li>Requisição de acesso aos seus dados pessoais. Este direito permite que você possa requisitar e receber uma
      cópia dos dados pessoais que a {{ RAZAO_SOCIAL }} e a Parceira possuem sobre você.</li>
    <li>Requisição de retificação dos seus dados pessoais. Este direito permite que você a qualquer momento possa
      solicitar a correção e/ou retificação dos seus dados pessoais, caso você identifique que alguns deles estão
      incorretos. Contudo, para ser efetivada essa correção, teremos que checar a validade dos dados que você
      fornece e, para isso, podemos solicitar documentos ou confirmações adicionais suas, como uma medida de
      segurança. Você pode retificar alguns dos seus dados pessoais entrando em contato com a {{ RAZAO_SOCIAL }}
      através dos Canais de Comunicação.</li>
    <li>Requisição de exclusão ou cancelamento dos seus dados pessoais. Este direito permite que você possa
      solicitar a exclusão dos seus dados pessoais armazenados nas bases de dados da {{ RAZAO_SOCIAL }} e da
      Parceira. Todos os dados coletados serão excluídos dos servidores quando você assim requisitar ou quando
      estes não forem mais necessários ou relevantes para lhe oferecermos os Serviços, salvo se houver qualquer
      outra razão para a sua manutenção, como eventual obrigação legal de retenção de dados ou necessidade de
      preservação destes para resguardo de direitos da {{ RAZAO_SOCIAL }} e da Parceira. Para alterar suas
      informações pessoais ou excluí-las do banco de dados da {{ RAZAO_SOCIAL }} e da Parceira, basta entrar em
      contato através dos Canais de Comunicação.</li>
    <li>Requisição de anonimização ou bloqueio dos seus dados pessoais. Caso Você entenda que a {{ RAZAO_SOCIAL }} e
      a Parceira estão solicitando dados excessivos ou desnecessários para as finalidades apontadas nesta Política
      de Privacidade, ou que estão tratando tais dados em desconformidade com a proteção prevista nesta Política
      de Privacidade, de forma que estariam violando as proteções previstas na Lei nº 13.709/18, Você pode
      solicitar o bloqueio, anonimização ou eliminação desses dados.</li>
    <li>Direito de objeção a um tratamento de dados. Caso você entenda, com relação aos dados cujo tratamento não se
      baseia no seu consentimento (mas, sim, em obrigação legal ou legítimo interesse), que a [Empresa] e a
      Parceira não estão processando de forma a proteger seus direitos e adimplir com as proteções dispostas nesta
      Política de Privacidade, de maneira que estariam violando os termos da Lei nº 13.709/18, você poderá opor-se
      ao tratamento desses dados. Quando a {{ RAZAO_SOCIAL }} e a Parceira estiverem tratando seus dados com base
      no legítimo interesse (ou de terceiros) e houver algo sobre sua situação específica que faça com que você
      deseje se opor ao tratamento dos seus dados nesse sentido, conforme julgar que isso causa um impacto
      negativo aos seus direitos e liberdades fundamentais, você também terá o direito de contestar a forma com a
      qual tratamos seus dados pessoais, como, por exemplo, para fins de marketing. Em alguns casos, ainda que
      isso ocorra, nós podemos demonstrar a você que temos motivos legítimos para tratar seus dados, os quais
      podem se sobrepor aos seus direitos, como nos casos em que os seus dados sejam essenciais para a prestação
      dos Serviços a você, para que um contrato firmado por você seja cumprido, ou mesmo para o cumprimento de uma
      obrigação legal a que a {{ RAZAO_SOCIAL }} e/ou a Parceira estejam sujeitas como consequência da relação
      estabelecida com você.</li>
    <li>Restringir o tratamento dos seus dados pessoais. Este direito permite que você peça para suspender o
      tratamento de seus dados pessoais nos seguintes cenários: (a) se você quiser que a {{ RAZAO_SOCIAL }} e a
      Parceira estabeleçam a precisão dos dados; (b) quando você precisar que os dados sejam mantidos por nós
      mesmo quando não precisarmos mais deles, conforme for necessário, por exemplo, para fazer, exercer ou
      responder a pedidos legais; ou (c) você se opuser ao uso de seus dados, ainda que precisemos verificar se
      temos motivos legítimos para usá-los.</li>
    <li>Solicitar revisão de decisões automatizadas tomadas com base nos dados coletados. Forneceremos a você a
      possibilidade de questionar uma decisão tomada automaticamente pelos sistemas da {{ RAZAO_SOCIAL }} e a
      Parceira, com base em seus dados.</li>
    <li>Solicitar a transferência de seus dados pessoais para você ou para terceiros. Forneceremos a você, ou a
      terceiros que você escolher, seus dados pessoais em formato estruturado.</li>
    <li>Direito de retirar o consentimento a qualquer momento. Você tem o direito de retirar o seu consentimento, no
      entanto, isso não afetará a legalidade de qualquer tratamento realizado antes de você retirar o seu
      consentimento. Se você retirar o seu consentimento, talvez não possam mais ser fornecidos determinados
      produtos e/ou prestados determinados Serviços. E se for este o caso, a {{ RAZAO_SOCIAL }} irá avisá-lo no
      momento em que isso ocorrer.</li>
    <li>Direito de não fornecer consentimento. Você tem o direito de não fornecer seu consentimento. No entanto,
      como os dados indicados nessa Política de Privacidade são necessários à prestação dos Serviços, a
      {{ RAZAO_SOCIAL }} e a Parceira não poderão fornecê-los à você caso você deixe de fornecer o seu
      consentimento para tanto. Caso discorde de parte dos dados solicitados ou de determinada finalidade que a
      {{ RAZAO_SOCIAL }} e a Parceira atribuirão a seus dados, você tem a alternativa de apresentar objeção ao
      tratamento de dados pessoais de que discordar e/ou requerer o acesso a seus dados.
    </li>
  </ul>

  <p> Para apresentar suas manifestações, solicitações e objeções relacionadas a essa Política de Privacidade, você
    deverá apresentar requerimento expresso, em seu nome ou por meio de seu representante legalmente constituído.
    Esse requerimento não terá qualquer custo e poderá ser encaminhado à {{ RAZAO_SOCIAL }} para o e-mail indicado
    na Cláusula 7 abaixo. Informações e dados que você solicitar poderão ser fornecidas via correio eletrônico ou
    sob forma impressa, a seu critério. </p>

  <p> Talvez seja necessário solicitar documentos e/ou informações específicas suas para ajudar a {{ RAZAO_SOCIAL }}
    e a Parceira, a confirmar sua identidade e garantir seu direito de acessar seus dados pessoais (ou de exercer
    seus outros direitos). Esta é uma medida de segurança para garantir que os dados pessoais não sejam divulgados a
    qualquer pessoa que não tenha direito de recebê-los. A {{ RAZAO_SOCIAL }} pode também contatá-lo para obter mais
    informações em relação à sua solicitação, a fim de acelerar a resposta. Serão fornecidas confirmações da
    existência de tratamento de dados e acesso a seus dados imediatamente, em formato simplificado, ou, por meio de
    declaração detalhada, no prazo de até 15 dias. Para demais comunicações e respostas às suas solicitações, como a
    portabilidade de seus dados, a {{ RAZAO_SOCIAL }} tentará responder a todas as solicitações legítimas dentro de,
    no máximo, 30 dias. Entretanto, o atendimento de solicitações dessa natureza pode levar mais de 30 dias se sua
    solicitação for particularmente complexa ou se você tiver feito várias solicitações. Neste caso, a
    {{ RAZAO_SOCIAL }} irá notificá-lo e mantê-lo atualizado sobre o andamento da sua solicitação.</p>

  <p> Caso você tenha alguma dúvida sobre essas questões e sobre como você pode exercer os direitos previstos nessa
    Política de Privacidade, fique à vontade para entrar em contato com a {{ RAZAO_SOCIAL }} através dos Canais de
    Comunicação.</p>

  <h3>5. POR QUANTO TEMPO OS DADOS SÃO ARMAZENADOS?</h3>

  <p> A {{ RAZAO_SOCIAL }} e a Parceira mantêm seus dados pessoais somente pelo tempo que for necessário para atingir
    as finalidades para as quais os coletamos, inclusive para fins de cumprimento de quaisquer obrigações legais,
    contratuais, de prestação de contas ou requisição de autoridades competentes, observado prazo mínimo de 5
    (cinco) anos contados da data da coleta dos dados, em observância ao disposto no art. 23, VIII da Resolução
    4.658/18 do Banco Central do Brasil.</p>

  <p> Para determinar o período de retenção adequado para os dados pessoais, consideramos a quantidade, a natureza e a
    sensibilidade dos dados pessoais, o risco potencial de danos decorrentes do uso não autorizado ou da divulgação
    de seus dados pessoais, a finalidade de tratamento dos seus dados pessoais e se podemos alcançar tais propósitos
    através de outros meios, observando os requisitos legais aplicáveis.</p>

  <p> E se você registrou uma Conta nos Serviços, as informações da sua Conta serão mantidas enquanto você mantiver
    essa conta ativa, observado o prazo legal acima mencionado, ou até que a finalidade para o qual os dados foram
    solicitados seja alcançada. Caso determinados dados deixem de ser necessários para o alcance de determinada
    finalidade, serão excluídos ou sujeitos à anonimização. Os dados também serão excluídos na hipótese de o Poder
    Público determinar o término do tratamento. </p>

  <p> Caso você solicite a exclusão dos seus dados e/ou da sua Conta, a {{ RAZAO_SOCIAL }} e a Parceira excluirão os
    seus dados ou os sujeitarão à anonimização, assim que decorrer o prazo legal de 5 (cinco) anos mencionado acima,
    a menos que a sua manutenção seja determinada com base em obrigações legais, ou requisição de autoridades
    competentes.</p>

  <h3>6. COMO FUNCIONA A SEGURANÇA DA INFORMAÇÃO?</h3>

  <p> Em nossos produtos e serviços aplicamos rígidos controles tecnológicos e procedimentais para garantir a
    segurança e proteção de todos os dados coletados e armazenados em nosso ambiente.</p>

  <p> Com a finalidade de garantir a proteção de seus dados pessoais e fornecer um ambiente seguro, adotamos práticas
    relativas à segurança da informação, como autenticação dos usuários, rígido controle de acesso, criptografia dos
    dados e do conteúdo das transações, prevenção e detecção de intrusão e acessos não autorizados, prevenção de
    vazamento de informações, realização periódica de testes e varreduras para detecção de vulnerabilidades,
    proteção contra softwares maliciosos, mecanismos de rastreabilidade, controles de acesso e de segmentação da
    rede de computadores, manutenção de cópias de segurança dos dados e das informações, entre outras.</p>

  <p> No entanto, além das proteções que a {{ RAZAO_SOCIAL }} aplica, é importante também que você tenha um
    comportamento seguro, identificando e evitando situações que possam ameaçar a segurança dos seus dados e de
    nossos produtos e serviços. Caso você identifique ou tome conhecimento de algo que comprometa a segurança dos
    seus dados, é essencial que entre em contato com a {{ RAZAO_SOCIAL }}.</p>

  <p> Em situações onde você utilize seus dados pessoais e de cartão para cadastro ou transações em sites ou serviço
    de terceiros, a responsabilidade de proteção e armazenamento dos dados nestes locais é dos provedores de tal
    serviço e você deve se atentar ao conteúdo das políticas de privacidade aplicáveis ao uso de tais sites ou
    serviços de terceiros. </p>

  <h3>7. COMO FALAR COM A {{ RAZAO_SOCIAL }}?</h3>

  <p> Se você acredita que suas informações pessoais foram usadas de maneira incompatível com esta Política ou com as
    suas escolhas enquanto titular destes dados, ou, ainda, se você tiver outras dúvidas, comentários, sugestões ou
    solicitações relacionadas a esta Política, você pode entrar em contato nos seguintes endereços de contato: </p>

  <p> E-mail: [{{ EMAIL_LGPD }}].</p>

  <h3>8. MUDANÇAS NA POLÍTICA </h3>

  <p> Como estamos sempre buscando melhorar os Serviços, essa Política pode passar por atualizações. Desta forma,
    recomendamos visitar periodicamente esta página para que você tenha conhecimento sobre as modificações. Caso
    sejam feitas alterações relevantes que necessitem de um novo consentimento seu, publicaremos essa atualização e
    solicitaremos um novo consentimento para você.</p>

  <p> *Em atendimento ao disposto no art. 41 da Lei n° 13.709 de 2018 (Lei Geral da Proteção de Dados), o contato com
    os Encarregados poderá ser feito pelo e-mail [{{ EMAIL_LGPD }}].</p>

  <p>***</p>

  <h1>TERMOS DE USO</h1>
  <small><b>Data de última atualização: {{ DATA_ULTIMA_ATUALIZACAO_TERMO }}.</b></small>

  <h3>INTRODUÇÃO: QUAL A FINALIDADE DESTES TERMOS DE USO?</h3>

  <p> Estes termos e condições gerais (“Termos de Uso”) regulam os principais direitos e obrigações dos usuários
    (“Titulares”) ao adquirirem e utilizarem os serviços aqui descritos (“Serviços”). </p>

  <p> AO UTILIZAR OS SERVIÇOS OFERECIDOS, O TITULAR AUTOMATICAMENTE CONCORDA COM TODAS AS REGRAS DESTES TERMOS DE USO
    E DEMAIS CONDIÇÕES AQUI MENCIONADAS, RESPONSABILIZANDO-SE INTEGRALMENTE POR TODOS E QUAISQUER ATOS PRATICADOS AO
    UTILIZAR NOSSOS SERVIÇOS. CASO O TITULAR NÃO CONCORDE COM QUALQUER DOS TERMOS E CONDIÇÕES ABAIXO ESTABELECIDOS,
    O TITULAR NÃO DEVE UTILIZAR OS SERVIÇOS.</p>

  <p> Os Serviços são oferecidos pela {{ RAZAO_SOCIAL }}, sociedade com sede no Estado de São Paulo e seus parceiros processadores de transações de
    pagamento e emissão de cartões.</p>

  <h3>1. QUAIS SÃO AS DEFINIÇÕES IMPORTANTES DESTES TERMOS DE USO?</h3>

  <p> 1.1. Sem prejuízo de outras definições atribuídas nestes Termos de Uso, as palavras abaixo, quando utilizadas no
    singular ou plural, terão os seguintes significados:</p>

  <ol type="i">
    <li>Aplicações: são aplicações de internet como, por exemplo, site ou aplicativo mobile, disponibilizados para
      que o Titular possa gerenciar sua Conta, na forma prevista nestes Termos de Uso. </li>
    <li>Bandeira: é o arranjo de pagamento instituído pela empresa responsável pela marca e pelos sistemas físicos e
      digitais que permitem a emissão do Cartão e utilização nos Estabelecimentos, de acordo com a Lei nº
      12.865/2013.
    </li>
    <li>Cartão: é um cartão físico e/ou virtual que, a critério da {{ NOME_FANTASIA }}, pode ser oferecido aos
      Titulares para usufruir os Serviços.</li>
    <li>Chargeback: é o procedimento de contestação de débito por meio do qual o Titular declara não reconhecer uma
      despesa efetuada com seu Cartão. Uma vez aceito o Chargeback, será realizado um depósito na Conta do
      Titular, no prazo informado pelos Canais de Comunicação.</li>
    <li>Canais de Comunicação: são os canais oficiais para comunicação entre o Titular e a {{ NOME_FANTASIA }}, para
      assuntos relacionados ao uso dos Serviços aqui descritos, sendo que qualquer outro canal de comunicação que
      não esteja descrito aqui, ou nas Aplicações, não é considerado um canal oficial, e o Titular não deve
      utilizá-lo. Os canais são os seguintes:
      <ol class="type-a">
        <li>E-mail. O e-mail oficial para contato é {{ EMAIL_CONTATO }};</li>
      </ol>
    </li>
    <li>Conta: é a conta de pagamento pré-paga, sediada na Parceira, destinada à execução de transações de pagamento
      em moeda eletrônica, realizadas com base em fundos denominados em reais previamente aportados. </li>
    <li>Estabelecimento: qualquer fornecedor de produtos e/ou serviços que está habilitado a aceitar pagamentos
      com o seu Cartão, no Brasil e/ou no exterior, em lojas físicas ou por meio da internet.</li>
    <li>Instituição Financeira: é o BANCO, instituição financeira responsável pelos serviços de individualização de
      Contas de Pagamento junto ao SPB (Sistema de Pagamento Brasileiro).</li>
    <li>Política de Privacidade: é o instrumento contratual que regula a coleta, uso, armazenamento, tratamento e
      segurança das informações pessoais dos Titulares, e que pode ser visualizada no inicio deste documento. A
      Política de Privacidade é parte integrante e inseparável destes Termos de Uso. A aceitação destes Termos de
      Uso implica na aceitação da Política de Privacidade.</li>
    <li>Titular: Pessoa Física ou Jurídica, titular da Conta. </li>
  </ol>

  <h3>2. QUAIS SÃO OS SERVIÇOS OFERECIDOS?</h3>

  <p> 2.1. A {{ NOME_FANTASIA }}, a Parceira e a Instituição Financeira, quando aplicável, oferecem ao Titular,
    diversos serviços que possibilitam a movimentação de recursos financeiros e a realização de transações de
    pagamento. Para isso, o Titular deverá se cadastrar em algumas das aplicações de internet da {{ NOME_FANTASIA }}
    (“Aplicações”).</p>

  <p> 2.2. Uma vez realizado o cadastro, o Titular terá acesso a uma Conta de pagamento e ao correspondente cartão
    físico e/ou virtual, para movimentação da Conta. O prazo para envio e recebimento deste Cartão, quando
    necessário será oportunamente informado pela {{ NOME_FANTASIA }}, e o acompanhamento da entrega poderá ser feito
    por meio dos Canais de Comunicação.</p>

  <p> 2.3. O Titular declara ter ciência de que sua Conta poderá ser rentabilizada de acordo com o saldo nela
    disponível, sem qualquer ônus ao Titular, que, por este instrumento, aceita receber tais eventuais rendimentos.
  </p>

  <h3>3. COMO EU ME CADASTRO PARA ACESSAR OS SERVIÇOS?</h3>

  <p> 3.1. Para utilizar os Serviços, o Titular deve cadastrar-se por meio das Aplicações.</p>

  <p> 3.2. O acesso aos Serviços é direcionado apenas às pessoas naturais maiores de 18 (dezoito) anos, residentes e
    domiciliadas no Brasil, que possuam plena capacidade legal e para Pessoas Jurídicas, devidamente inscritas junto
    aos órgãos pertinentes ao Registro de Empresa. A utilização dos Serviços destina-se ao uso pessoal do Titular
    ou, no caso contas destinadas às Pessoas Jurídicas, o uso se limitará à(s) pessoa(s) autorizadas a movimentar a
    conta de pagamento em nome da empresa.</p>

  <p> 3.3. Para efetuar o cadastro, o Titular deve preencher certas informações pessoais, em observância ao art. 4º da
    Circular 3680/2013 do BACEN, como por exemplo: nome completo ou razão social, data de nascimento ou data de
    constituição, número de inscrição no Cadastro de Pessoa Física (CPF) ou Cadastro Nacional de Pessoas Jurídicas
    (CNPJ); endereço residencial ou comercial; número de telefone com DDD; e-mail, nome de usuário (login), senha,
    bem como outras informações que podem ser exigidas pela {{ NOME_FANTASIA }} ou pela Parceira e necessárias para
    essa finalidade. O Titular declara que as Informações Pessoais fornecidas voluntariamente no momento do cadastro
    são corretas, completas e verdadeiras e compromete-se a sempre manter as Informações Pessoais atualizadas nas
    Aplicações, responsabilizando-se por qualquer resultado ou prejuízo decorrente da falsidade das suas Informações
    Pessoais ou da não atualização delas.</p>

  <p> A {{ NOME_FANTASIA }}, a Parceira e a Instituição Financeira, quando aplicável, em hipótese alguma serão
    responsáveis pela veracidade das Informações Pessoais. Caso a {{ NOME_FANTASIA }} e a Parceira detectem a
    abertura de conta a partir de informações falsas, incompletas, equivocadas, errôneas, enganosas, ou, ainda, que
    não permita identificar a identidade do Titular, elas poderão (i) solicitar esclarecimentos e documentação
    adicional que julgarem necessários para a devida comprovação das informações prestadas e para a validação do
    cadastro, podendo, inclusive, recusarem-se a validar qualquer cadastro, a seu exclusivo critério ou (ii)
    automaticamente excluir o seu cadastro, suspender ou cancelar a sua permissão de utilizar os Serviços.</p>

  <p> 3.4. Todas as Informações Pessoais fornecidas voluntariamente pelo Titular no momento do cadastro estão sujeitas
    às medidas de segurança que as protejam do acesso, do uso e da divulgação não autorizados. Para saber mais sobre
    a forma como a {{ NOME_FANTASIA}} coleta e processa suas Informações Pessoais, por favor, leia a Política de
    Privacidade da {{ NOME_FANTASIA}} no inicio deste documento.</p>

  <p> 3.5. Uma vez que o cadastro tenha sido realizado e aprovado, o Titular passará a ter acesso a Conta, por meio
    unicamente das Aplicações, mediante a utilização do login e senha criados no momento do cadastro. O Titular é o
    único responsável por sua Conta e por qualquer atividade associada a esta Conta. Neste sentido, é proibido o
    compartilhamento, pelo Titular, de seu login e senha com terceiros, devendo comunicar imediatamente à
    {{ NOME_FANTASIA }} no caso de perda, extravio ou furto de seu Cartão, login e/ou senha.</p>

  <p> A {{ NOME_FANTASIA }}, A PARCEIRA E A INSTITUIÇÃO FINANCEIRA, QUANDO APLICÁVEL, NÃO SERÃO RESPONSÁVEIS POR
    ACESSOS OU MOVIMENTAÇÕES EM SUA CONTA E/OU PELO USO INDEVIDO DE SEU CARTÃO POR TERCEIROS, BEM COMO POR QUALQUER
    DANO DIRETO OU INDIRETO QUE RESULTE DO MAU USO OU DA INABILIDADE DO USO DAS APLICAÇÕES, DA CONTA OU DO CARTÃO
    PELO TITULAR OU POR QUAISQUER TERCEIROS, SENDO CERTO QUE, HAVENDO EVIDÊNCIAS OU, AINDA, MEROS INDÍCIOS DE USO
    IRREGULAR, INADEQUADO, OU SUSPEITO DO CARTÃO E/OU DA CONTA, O TITULAR PODERÁ TER SEU CADASTRO IMEDIATAMENTE
    SUSPENSO OU, AINDA, CANCELADO, SEM PREJUÍZO DAS DEMAIS SANÇÕES LEGAIS E CONTRATUAIS.</p>

  <p> 3.6. O Titular reconhece que as informações fornecidas voluntariamente poderão ser compartilhadas com a
    Instituição Financeira, na medida necessária para disponibilização dos serviços oferecidos bem como para fins de
    registro ou qualquer outra finalidade, incluindo, mas não se limitando à comercialização de produtos da
    [EMPRESA] e da Parceira.</p>

  <h3> 4. QUAIS SERVIÇOS SÃO OFERECIDOS POR MEIO DA CONTA DE PAGAMENTO?</h3>

  <p> 4.1. Entre as principais operações que o Titular pode realizar por meio da Conta, sempre sujeitas à
    disponibilidade de saldo, destacamos os seguintes “Serviços”:</p>

  <ol type="i">
    <li>Compras em Estabelecimentos: o Titular poderá realizar compras em qualquer fornecedor de produtos e/ou
      serviços que estejam habilitados a aceitar pagamentos com o seu Cartão, no Brasil e/ou no Exterior, em lojas
      físicas ou por meio da internet (“Estabelecimentos”);</li>
    <li>Saque: retirada de recursos em terminais eletrônicos habilitados, mediante uso do Cartão. Nesta hipótese,
      poderão ser cobradas taxas pelas empresas administradoras desses terminais;</li>
    <li>Transferências entre Contas: Dependendo do produto, o Titular poderá transferir recursos financeiros da sua
      Conta para de terceiros, podendo ser cobradas taxas e tributos específicos para essas transferências, que
      serão descontados do saldo do Titular. A transferência entre contas também deverá observar os prazos e
      procedimentos previstos pelo sistema financeiro brasileiro;</li>
    <li>Pagamento de Boletos e Contas de Consumo: o Titular poderá realizar pagamentos de boletos e contas de
      consumo, sempre sujeito às limitações impostas pela legislação brasileira e pelas empresas emissoras dos
      respectivos títulos/boletos;</li>
    <li>Recarga de Celular: o Titular poderá realizar pagamentos para a recarga de celular das operadoras
      cadastradas, sujeito às regras específicas de cada operadora.</li>
  </ol>

  <p> 4.2. Para ativar o uso de sua Conta, o Titular deve fazer aporte de um valor, por meio das seguintes
    alternativas:</p>

  <ol type="i">
    <li>
      <p>Transferência Bancária: transferências bancárias efetuadas pelos aplicativos dos bancos, pelo Internet
        Banking e/ou caixas eletrônicos, e;</p>
      <p> CADA OPERAÇÃO AQUI DESCRITA PODE TER LIMITAÇÕES TÉCNICAS E ESPECIFICAÇÕES DEFINIDAS PELA {{
        NOME_FANTASIA }}, BEM COMO UMA REMUNERAÇÃO ESPECÍFICA, DE ACORDO COM O SERVIÇO REALIZADO, QUE SERÁ
        COBRADA MEDIANTE DÉBITO EM CONTA. O VALOR DE CADA TARIFA ESTÁ DISPONÍVEL AOS TITULARES NAS APLICAÇÕES.
      </p>
      <p> A {{ NOME_FANTASIA }} RESERVA O DIREITO DE ALTERAR AS TARIFAS A QUALQUER MOMENTO, SEMPRE INFORMANDO
        PREVIAMENTE OS TITULARES, DE ACORDO COM A REGULAMENTAÇÃO APLICÁVEL, SENDO FACULTADO AO TITULAR CONCORDAR
        COM TAL ALTERAÇÃO OU CANCELAR SEU CADASTRO.</p>
    </li>
  </ol>

  <h3>5. QUAIS SÃO AS FINALIDADES DO USO DO MEU CARTÃO?</h3>

  <p> 5.1. Assim que receber o Cartão, o Titular ficará responsável por conferir os seus dados, sendo certo que o
    Cartão será entregue bloqueado, por medida de segurança e o desbloqueio deverá ser realizado por meio das
    Aplicações.</p>

  <p> 5.2. O Titular deverá se atentar para o regulamento do arranjo de pagamento da Bandeira, aplicável ao
    Cartão (“Regulamento”), uma vez que cada Bandeira é regida por condições e termos específicos.</p>

  <p> 5.3. Ao utilizar o Cartão, o Titular estará automaticamente submetido aos regulamentos específicos da Bandeira,
    conforme a Lei nº 12.865/2013.</p>

  <p> O TITULAR É O ÚNICO RESPONSÁVEL PELO USO E GUARDA DO SEU CARTÃO FÍSICO. RECOMENDA-SE QUE O TITULAR: (I) GUARDE
    SEU CARTÃO EM LOCAL SEGURO, JAMAIS PERMITINDO SEU USO POR TERCEIROS; (II) MEMORIZE SUA SENHA E MANTENHA-A EM
    SIGILO, EVITANDO ANOTAR OU GUARDAR A SENHA EM SUPORTES FÍSICOS OU DIGITAIS, E; (III) NUNCA ANOTE OU GUARDE A
    SENHA EM CONJUNTO COM SEU CARTÃO.</p>

  <p> RECOMENDA-SE AINDA QUE O TITULAR NÃO UTILIZE SENHAS RELACIONADAS A DATAS OU OUTRAS REFERÊNCIAS PESSOAIS DO
    TITULAR E QUE EFETUE ROTINEIRAMENTE A TROCA DE SUA SENHA COMO MEDIDA DE SEGURANÇA.</p>

  <p> 5.4. Se por qualquer razão, o Titular realizar uma transação que seja autorizada ainda que haja
    indisponibilidade de saldo na Conta, este se compromete a efetuar o pagamento do valor devido pela transação à
    {{ NOME_FANTASIA }} no prazo de até 30 dias contados da comunicação do fato pela {{ NOME_FANTASIA }}.</p>

  <p> 5.5. Caso o Titular não efetue o pagamento neste prazo, a {{ NOME_FANTASIA }} independentemente de prévia
    notificação, visando o recebimento do valor correspondente à transação efetuada, poderá tomar as medidas que
    julgar adequadas, tais como, mas não se limitando a, (i)bloqueio de transações de cash out, (ii) registro de
    informações do Titular no SERASA, SPC ou qualquer outro serviço similar de proteção ao crédito e/ou (iii)
    acionamento judicial ou extrajudicial do Titular, respeitados os prazos legais aplicáveis.</p>

  <p> 5.6. De toda forma, independentemente de tais medidas, assim que houver saldo suficiente em Conta, a
    {{ NOME_FANTASIA }} poderá automaticamente debitar o valor da transação, sem prévia notificação ao Titular,
    observado que, restituídos os valores à {{ NOME_FANTASIA }}, esta restabelecerá os serviços ou medidas aplicadas
    ao Titular em virtude do débito ressarcido.</p>

  <h3>6. PERDI O CARTÃO, O QUE FAÇO?</h3>

  <p> Em caso de perda, extravio, furto ou roubo do Cartão, o Titular deve entrar em contato imediatamente com
    qualquer um dos Canais de Comunicação. Após seu contato, o uso e acesso da Conta poderá ser temporariamente
    bloqueado, até que o Titular receba novo login e senha. Um novo Cartão será preparado para o Titular, e será
    entregue nos prazos informados pelos Canais de Comunicação. Poderão ser cobradas tarifas adicionais para gerar
    um novo Cartão, e, nesta hipótese, tais tarifas serão previamente informadas ao Titular.</p>

  <h3>7. NÃO RECONHEÇO UMA OPERAÇÃO FEITA COM MEU CARTÃO, O QUE FAÇO?</h3>

  <p> 7.1. Caso o Titular não reconheça uma operação feita com o seu Cartão, deverá entrar em contato com qualquer um
    dos Canais de Comunicação no prazo máximo de 90 (noventa) dias e seguir as orientações para realização do
    procedimento de Chargeback. O procedimento e a documentação exigida para o Chargeback seguirão as regras
    estabelecidas pela Bandeira e pela Parceira, de forma que a aprovação do Chargeback só será efetuada quando
    comprovado o erro ou desacordo comercial e não houver culpa exclusiva do Titular, nos termos das regras
    supracitadas. Aprovado o Chargeback, o valor será creditado à Conta do Titular, no prazo estabelecido pela
    Parceira.</p>

  <p> O TITULAR ESTÁ CIENTE E DE ACORDO QUE O PROCEDIMENTO DE CHARGEBACK SOMENTE OCORRERÁ PARA TRANSAÇÕES ONLINE. NÃO
    SERÃO ACEITOS PROCEDIMENTOS DE CHARGEBACK PARA TRANSAÇÕES REALIZADAS COM O CARTÃO FÍSICO EM ESTABELECIMENTOS OU
    POR MEIO DAS APLICAÇÕES E QUE TENHAM SIDO EFETUADAS ATRAVÉS DE LOGIN E SENHA CORRETOS.</p>

  <h3>8. COMO CANCELO OS SERVIÇOS?</h3>

  <p> 8.1. O Titular poderá, a qualquer momento, solicitar o cancelamento de sua Conta e Cartão, mediante solicitação
    realizada pelos Canais de Comunicação. </p>

  <p> 8.2. Uma vez solicitado o cancelamento, o Cartão será bloqueado e a Conta será definitivamente encerrada dentro
    do prazo máximo estabelecido na regulamentação aplicável, sendo facultado ao Titular, dentro deste prazo: (i)
    sacar o saldo remanescente; ou (ii) realizar sua transferência para outra conta.</p>

  <h3>9. EM QUAIS SITUAÇÕES A {{ NOME_FANTASIA }} E/OU A PARCEIRA PODEM CANCELAR MEUS SERVIÇOS?</h3>

  <p> 9.1. A {{ NOME_FANTASIA }} ou a Parceira poderão cancelar a prestação dos Serviços imediatamente, comunicando o
    Titular, nas seguintes hipóteses:</p>

  <ol type="i">
    <li>caso a Conta fique inativa e com saldo zerado por mais de 3 meses consecutivos;</li>
    <li>caso o Titular viole quaisquer das disposições destes Termos de Uso;</li>
    <li>caso sejam verificadas operações fora do padrão de uso, e o Titular deixe de atender pedido de envio de
      novos documentos para a comprovação da regularidade dessas operações;</li>
    <li>em caso de falecimento do Titular.</li>
  </ol>

  <p> 9.2 A prestação dos Serviços, pode, ainda, ser cancelada imotivadamente e a qualquer momento, mediante
    comunicação ao Titular com, no mínimo, 30 (trinta) dias de antecedência.</p>

  <p> 9.3 Exceto nos casos de suspeita de fraude, havendo saldo remanescente na Conta, o Titular deverá indicar conta
    corrente de mesma titularidade para liberação do valor.</p>

  <h3>10. DE QUEM É A PROPRIEDADE INTELECTUAL SOBRE OS SERVIÇOS?</h3>

  <p> 10.1. Todos os direitos de propriedade intelectual relativos aos Serviços, bem como todas as suas
    funcionalidades, são de titularidade exclusiva da {{ NOME_FANTASIA }}, da Parceira e da Instituição de
    Pagamento, quando aplicável e conforme o caso, inclusive no que diz respeito aos seus textos, imagens, layouts,
    software, códigos, base de dados, gráficos, artigos, fotografias e demais conteúdos produzidos direta ou
    indiretamente pela Parceira (“Conteúdo”). O Conteúdo é protegido pela lei brasileira de direitos autorais e de
    propriedade industrial. É proibido usar, copiar, reproduzir, modificar, traduzir, publicar, transmitir,
    distribuir, executar, fazer o upload, exibir, licenciar, vender, explorar ou fazer engenharia reversa do
    Conteúdo, para qualquer finalidade, sem o consentimento prévio e expresso da {{ NOME_FANTASIA }}, da Parceira ou
    da Instituição Financeira. Qualquer uso não autorizado do Conteúdo será considerado como violação dos direitos
    autorais e de propriedade intelectual da Parceira.</p>

  <p> 10.2. A {{ NOME_FANTASIA }}, a Parceira e a Instituição Financeira, quando aplicável, concedem ao Titular uma
    licença limitada, temporária, não exclusiva, não transferível e revogável, para usar os Serviços e as Aplicações
    somente naquilo que seja estritamente necessário para o cumprimento das obrigações e exercício dos direitos
    previstos nestes Termos de Uso. É proibido ao Titular ceder, sublicenciar, doar, alienar, alugar, transmitir ou
    transferir os seus direitos e obrigações a terceiros, total ou parcialmente, sob quaisquer modalidades, a
    qualquer título, bem como é vedado adaptar, descompilar, desmontar ou executar engenharia reversa das
    Aplicações, de forma que viole os direitos aqui previstos.</p>

  <p> 10.3. A {{ NOME_FANTASIA }} e a Parceira reservam-se o direito de, a seu critério e a qualquer tempo:</p>

  <ol type="i">
    <li>alterar ou remover funcionalidades das Aplicações que não estejam alinhadas com seus interesses, bem como
      adicionar novas que tragam benefícios à utilização das Aplicações, sem qualquer comunicação prévia ao
      Titular e sem que lhe seja devida qualquer indenização;</li>
    <li>descontinuar de forma definitiva ou temporária os Serviços disponibilizados por meio da Aplicações,
      mediante comunicação prévia ao Titular e sem que lhe seja devida qualquer indenização. Nos casos de
      descontinuidade definitiva das Aplicações, as Partes disponibilizarão os valores que estiverem na conta dos
      Titulares; e </li>
    <li>suspender, bloquear preventivamente ou cancelar o cadastro do Titular, bem como qualquer acesso e uso das
      Aplicações, pelo período estabelecido na regulamentação aplicável, em caso de mera suspeita de fraude,
      obtenção de benefício ou vantagem de forma ilícita, ou pelo não cumprimento de quaisquer condições previstas
      nestes Termos de Uso ou na legislação aplicável. Nesses casos, não será devida qualquer indenização ao
      Titular e, a {{ NOME_FANTASIA }} e a Parceira poderão promover a competente ação de regresso, se necessário,
      bem como tomar quaisquer outras medidas necessárias para perseguir e resguardar seus interesses.</li>
  </ol>

  <p> 10.4. Todos os anúncios, ofertas, promoções, marcas, textos e conteúdos de terceiros veiculados através das
    Aplicações são de propriedade de seus respectivos titulares, sendo expressamente proibida a utilização indevida
    de quaisquer conteúdos ou marcas apresentadas nas Aplicações.</p>

  <h3>11. QUAIS SÃO AS LIMITAÇÕES DE RESPONSABILIDADE?</h3>

  <p> 11.1. NEM A {{ NOME_FANTASIA }} NEM A PARCEIRA OU A INSTITUIÇÃO FINANCEIRA, QUANDO APLICÁVEL, SÃO RESPONSÁVEIS
    PELAS TRANSAÇÕES REALIZADAS PELOS TITULARES POR MEIO DA CONTA, UMA VEZ QUE NÃO SÃO PARTE DE QUALQUER OPERAÇÃO DE
    COMPRA E VENDA JUNTO A ESTABELECIMENTOS.</p>

  <p> 11.2. É DE RESPONSABILIDADE DO TITULAR: (I) MANTER SEGURO O AMBIENTE DE SEUS DISPOSITIVOS DE ACESSO ÀS
    APLICAÇÕES, VALENDO-SE DE FERRAMENTAS ESPECÍFICAS PARA TANTO, TAIS COMO ANTIVÍRUS, FIREWALL, ENTRE OUTRAS, DE
    MODO A CONTRIBUIR PARA A PREVENÇÃO DE RISCOS ELETRÔNICOS; (II) UTILIZAR SISTEMAS OPERACIONAIS ATUALIZADOS E
    EFICIENTES PARA A PLENA UTILIZAÇÃO DAS APLICAÇÕES; E (III) EQUIPAR-SE E RESPONSABILIZAR-SE PELOS DISPOSITIVOS DE
    HARDWARE NECESSÁRIOS PARA O ACESSO ÀS APLICAÇÕES, BEM COMO PELO ACESSO DESSES À INTERNET.</p>

  <p> 11.3. TODAS AS COMUNICAÇÕES REALIZADAS PELA {{ NOME_FANTASIA }} COM O TITULAR SERÃO FEITAS ATRAVÉS DAS
    APLICAÇÕES OU DO E-MAIL INDICADO PELO TITULAR NO MOMENTO DO CADASTRO. É DEVER DO TITULAR DEIXAR OS SISTEMAS DE
    ANTI-SPAM CONFIGURADOS DE MODO QUE NÃO INTERFIRAM NO RECEBIMENTO DOS COMUNICADOS. A RESPONSABILIDADE PELO
    RECEBIMENTO E VISUALIZAÇÃO DOS COMUNICADOS É EXCLUSIVA DO TITULAR.</p>

  <p> 11.4. NEM A {{ NOME_FANTASIA }} NEM A PARCEIRA OU A INSTITUIÇÃO FINANCEIRA, QUANDO APLICÁVEL, SÃO RESPONSÁVEIS
    PELA VERACIDADE DAS INFORMAÇÕES PESSOAIS OFERECIDAS PELO TITULAR, DE FORMA QUE A RESPONSABILIDADE PELO CONTEÚDO
    DAS INFORMAÇÕES PESSOAIS É EXCLUSIVA DO TITULAR. O TITULAR ENTENDE QUE A UTILIZAÇÃO DOS SERVIÇOS É VOLTADA
    APENAS PARA FINS LÍCITOS. A {{ NOME_FANTASIA }} E/OU A PARCEIRA RESERVAM-SE O DIREITO DE IMEDIATAMENTE
    INTERROMPER O ACESSO À CONTA PELO TITULAR, CASO IDENTIFIQUE A FALSIDADE NO CONTEÚDO DAS INFORMAÇÕES PESSOAIS,
    BEM COMO A MÁ UTILIZAÇÃO OU USO INADEQUADO DOS SERVIÇOS.</p>

  <p> 11.5. TENDO EM VISTA AS CARACTERÍSTICAS INERENTES AO AMBIENTE DA INTERNET, O TITULAR RECONHECE QUE NEM A
    {{ NOME_FANTASIA }} NEM A PARCEIRA OU A INSTITUIÇÃO FINANCEIRA, QUANDO APLICÁVEL, SE RESPONSABILIZAM PELAS
    FALHAS NA PLATAFORMA DECORRENTES DE CIRCUNSTÂNCIAS ALHEIAS À SUA VONTADE E CONTROLE, SEJAM OU NÃO OCASIONADAS
    POR CASO FORTUITO OU FORÇA MAIOR, COMO POR EXEMPLO, INFORMAÇÕES PERDIDAS, INCOMPLETAS, INVÁLIDAS OU CORROMPIDAS;
    INTERVENÇÕES DE HACKERS E SOFTWARE MALICIOSOS; FALHAS TÉCNICAS DE QUALQUER TIPO, INCLUINDO, FALHAS NO ACESSO OU
    NA NAVEGAÇÃO DO SITE DECORRENTES DE FALHAS NA INTERNET EM GERAL, QUEDAS DE ENERGIA, MAU FUNCIONAMENTO ELETRÔNICO
    E/OU FÍSICO DE QUALQUER REDE, INTERRUPÇÕES OU SUSPENSÕES DE CONEXÃO E FALHAS DE SOFTWARE E/OU HARDWARE DO
    TITULAR; PARALISAÇÕES PROGRAMADAS PARA MANUTENÇÃO, ATUALIZAÇÃO E AJUSTES DE CONFIGURAÇÃO DAS APLICAÇÕES;
    QUALQUER FALHA HUMANA DE QUALQUER OUTRO TIPO, QUE POSSA OCORRER DURANTE O PROCESSAMENTO DAS INFORMAÇÕES,
    EXIMINDO-SE DE QUALQUER RESPONSABILIDADE PROVENIENTE DE TAIS FATOS E/OU ATOS.</p>

  <h3>12. COMO ENTRO EM CONTATO PARA DÚVIDAS E SOLICITAÇÕES?</h3>

  <p> 12.1. Qualquer dúvida ou solicitação deverá ser sempre encaminhada aos Canais de Comunicação. Qualquer outra
    forma de comunicação com a {{ NOME_FANTASIA }} ou com a Parceira que seja realizada fora dos Canais de
    Comunicação não será reconhecida.</p>

  <p> O TITULAR OBRIGA-SE A INFORMAR IMEDIATAMENTE QUAISQUER MUDANÇAS DE NÚMERO DE TELEFONE, ENDEREÇO E ENDEREÇO DE
    E-MAIL, A FIM DE QUE POSSA RECEBER REGULARMENTE COMUNICAÇÕES IMPORTANTES DOS CANAIS DE COMUNICAÇÃO.</p>

  <h3>13. O QUE MAIS PRECISO SABER?</h3>

  <p> 13.1. Atualizações. A Parceira e {{ NOME_FANTASIA }} estão sempre fazendo atualizações nas Aplicações, por esse
    motivo, durante a vigência destes Termos de Uso, a Parceira e a {{ NOME_FANTASIA }} poderão atualizar as
    Aplicações com o objetivo de preservar ou aperfeiçoar suas características funcionais. Nesse caso, suspensões
    temporárias nos Serviços poderão acontecer e o Titular deverá baixar as versões atualizadas das Aplicações, caso
    queira fazer uso dessas atualizações. Os Termos de Uso poderão ser alterados, a qualquer tempo, a fim de
    refletir os ajustes realizados nas Aplicações quando necessário e aplicável. No entanto, sempre que ocorrer
    qualquer modificação nestes Termos de Uso, o Titular será informado por meio de uma nota em destaque dentro das
    Aplicações. Caso o Titular não concorde com os novos Termos de Uso, poderá rejeitá-los, mas, infelizmente, isso
    significa que o Titular não poderá mais fazer uso das Aplicações. Se de qualquer maneira o Titular utilizar as
    Aplicações mesmo após a alteração destes Termos de Uso, isso significa que o Titular concorda com todas as
    modificações.</p>

  <p> 13.2. Aplicativos de Terceiros. Atualmente, uma série de soluções de hardware e software oferecem a
    possibilidade de integração com outras aplicações (“Aplicações de Terceiros”), sendo que alguns desses
    Aplicativos de Terceiros poderão ter sua integração com as Aplicações disponibilizadas pela Parceira. O uso
    dessas Aplicações de Terceiros é de única e exclusiva responsabilidade dos Titulares, que se obrigam, ainda, a
    não integrar as Aplicações, sua Conta ou seu Cartão a quaisquer outras Aplicações de Terceiros que não sejam
    autorizadas pela {{ NOME_FANTASIA }} e pela Parceira. As Aplicações de Terceiros poderão ter seus próprios
    termos e condições de uso e políticas de privacidade e, então, também serão regidas pelos respectivos termos e
    condições, e às respectivas políticas de privacidade. O TITULAR COMPREENDE E CONCORDA QUE A {{ NOME_FANTASIA }},
    A PARCEIRA, A BANDEIRA OU A INSTITUIÇÃO FINANCEIRA, QUANDO APLICÁVEL, NÃO ENDOSSAM E NÃO SÃO RESPONSÁVEIS PELO
    COMPORTAMENTO, RECURSOS OU CONTEÚDO DE QUAISQUER APLICAÇÕES DE TERCEIRO, OU POR QUALQUER TRANSAÇÃO QUE O TITULAR
    POSSA FAZER COM O PROVEDOR DE TAIS APLICAÇÕES DE TERCEIROS.</p>

  <p> 13.3. Comunicação ao BACEN. O Titular desde já concorda que as Partes comunicarão ao Banco Central do Brasil, ao
    Conselho de Controle de Atividades Financeiras ou outros órgãos que a legislação previr, as operações que possam
    estar configuradas na Lei 9.613/98 (que dispõe sobre os crimes de lavagem ou ocultação de bens, direitos e
    valores) e demais disposições legais pertinentes à matéria.</p>

  <p> 13.4. Cessão. A {{ NOME_FANTASIA }} e a Parceira poderão, a qualquer momento, ceder quaisquer de seus direitos e
    obrigações previstos nestes Termos de Uso a qualquer pessoa, física ou jurídica, mediante simples notificação
    prévia ao Titular, ficando desde já ressalvado que a cessionária continuará a cumprir com todas as obrigações
    assumidas pela {{ NOME_FANTASIA }} e/ou Parceira, conforme o caso.</p>

  <p> 13.5. Lei Aplicável. Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Quaisquer
    dúvidas e situações não previstas nestes Termos de Uso serão primeiramente resolvidas pela {{ NOME_FANTASIA }}
    e, caso persistam, deverão ser solucionadas pelos órgãos do sistema brasileiro de defesa do consumidor.</p>

  <p> ***</p>

</article>


// WEBPACK FOOTER //
// ./src/app/politica-termo/politica-termo.component.html